export default __webpack_public_path__ + "static/media/scrollingArrow.9113370e.svg";